module.exports = __webpack_public_path__ + "img/drag.3d818e84.svg";